import VolumeBox from 'components/instruments/VolumeBox.js';
import {updateTrackVolume} from 'operations/actions.js';
import React from 'react';

export default function InstallationVolume({track, sequencerEngine}) {
    return (
        <VolumeBox
          track={track}
          rackTrack={{trackNumber: 0}}
          width={54}
          min={-60}
          onVolumeChange={
              (v) => sequencerEngine.operationManager.dispatch(
                  updateTrackVolume(track, v))
          }/>
    );
}
